import React from 'react';
import styled from 'styled-components';
import { MdKeyboardArrowDown } from 'react-icons/md';

const InputRow = styled.div`
  margin-bottom: 20px;
`;

const InputTopRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  gap: 12px;
`;

const Label = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.xs};
  color: ${({ theme }) => theme.colors.text.primary};
  font-weight: ${({ theme }) => theme.typography.fontWeights.medium};
  font-family: inherit;
  flex-shrink: 0;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    font-size: 14px;
  }
`;

const InputWrapper = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  width: 288px;

  @media (max-width: 768px) {
    flex-direction: column;
    max-width: 150px;
    gap: 12px;
  }
`;

const SelectLabel = styled.span`
  position: absolute;
  top: -10px;
  left: 10px;
  background: ${({ theme }) => theme.colors.white};
  padding: 0 5px;
  font-size: ${({ theme }) => theme.typography.fontSizes.xs};
  color: ${({ theme }) => theme.colors.text.secondary};
  font-family: inherit;

  @media (max-width: 768px) {
    font-size: 10px;
  }
`;

const StyledSelect = styled.select`
  appearance: none;
  padding: 8px 35px 8px 12px;
  font-size: ${({ theme }) => theme.typography.fontSizes.md};
  font-family: inherit;
  font-weight: ${({ theme }) => theme.typography.fontWeights.bold};
  border: 1px solid #e2e8f0;
  border-radius: ${({ theme }) => theme.borderRadius.sm};
  background: ${({ theme }) => theme.colors.white};
  cursor: pointer;
  width: 100%;
  height: 40px;

  @media (max-width: 768px) {
    font-size: 14px;
    padding: 6px 30px 6px 10px;
    height: 36px;
  }

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.colors.primary};
  }
`;

const SelectContainer = styled.div`
  position: relative;
  flex: 1;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const DownArrow = styled.span`
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-40%);
  pointer-events: none;
  color: ${({ theme }) => theme.colors.text.secondary};
  font-size: 20px;
`;

interface TimePeriodSelectorProps {
  years: number;
  months: number;
  onYearsChange: (years: number) => void;
  onMonthsChange: (months: number) => void;
}

export const TimePeriodSelector: React.FC<TimePeriodSelectorProps> = ({
  years,
  months,
  onYearsChange,
  onMonthsChange,
}) => {
  return (
    <InputRow>
      <InputTopRow>
        <Label>Time Period (Years)</Label>
        <InputWrapper>
          <SelectContainer>
            <SelectLabel>Years</SelectLabel>
            <StyledSelect value={years} onChange={(e) => onYearsChange(Number(e.target.value))}>
              {[...Array(30)].map((_, i) => (
                <option key={i + 1} value={i + 1}>
                  {i + 1}
                </option>
              ))}
            </StyledSelect>
            <DownArrow>
              <MdKeyboardArrowDown />
            </DownArrow>
          </SelectContainer>
          <SelectContainer>
            <SelectLabel>Months</SelectLabel>
            <StyledSelect value={months} onChange={(e) => onMonthsChange(Number(e.target.value))}>
              {[...Array(12)].map((_, i) => (
                <option key={i} value={i}>
                  {i}
                </option>
              ))}
            </StyledSelect>
            <DownArrow>
              <MdKeyboardArrowDown />
            </DownArrow>
          </SelectContainer>
        </InputWrapper>
      </InputTopRow>
    </InputRow>
  );
};
